import React from "react";

const THEME = {
  primary: "#FB565F",
  success: "#10b981",
  successLight: "#d1fae5",
  danger: "#dc2626",
  dangerLight: "#fee2e2",
  warning: "#f59e0b",
  warningLight: "#fef3c7",
  gray: "#6b7280",
  grayLight: "#f3f4f6",
};

const MiniStat = ({ label, value, color, bgColor }) => (
  <div
    className="flex flex-col p-4 rounded-xl border-2 transition hover:shadow-md"
    style={{ borderColor: bgColor, backgroundColor: `${bgColor}40` }}>
    <p className="text-gray-600 font-medium text-xs sm:text-sm">{label}</p>
    <p className="text-xl sm:text-2xl font-bold mt-1" style={{ color }}>
      {value ?? 0}
    </p>
  </div>
);

export default function DashboardProposalsDetail({ proposalsAnalytics }) {
  return (
    <div className="mb-6 lg:mb-8">
      <h2 className="font-main text-lg sm:text-xl font-bold text-gray-900 mb-4">
        Daily & Monthly Proposals
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="bg-white rounded-2xl shadow-lg border-2 border-gray-100 overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100" style={{ backgroundColor: THEME.primaryLight }}>
            <h3 className="font-main font-bold text-gray-800">Daily</h3>
          </div>
          <div className="p-4 grid grid-cols-3 gap-3">
            <MiniStat
              label="Sent"
              value={proposalsAnalytics?.today_proposals}
              color={THEME.gray}
              bgColor="#e5e7eb"
            />
            <MiniStat
              label="Accepted"
              value={proposalsAnalytics?.today_accepted_proposals}
              color={THEME.success}
              bgColor={THEME.successLight}
            />
            <MiniStat
              label="Rejected"
              value={proposalsAnalytics?.today_rejected_proposals}
              color={THEME.danger}
              bgColor={THEME.dangerLight}
            />
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border-2 border-gray-100 overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100" style={{ backgroundColor: THEME.primaryLight }}>
            <h3 className="font-main font-bold text-gray-800">Monthly</h3>
          </div>
          <div className="p-4 grid grid-cols-3 gap-3">
            <MiniStat
              label="Sent"
              value={proposalsAnalytics?.month_proposals}
              color={THEME.gray}
              bgColor="#e5e7eb"
            />
            <MiniStat
              label="Accepted"
              value={proposalsAnalytics?.month_accepted_proposals}
              color={THEME.success}
              bgColor={THEME.successLight}
            />
            <MiniStat
              label="Rejected"
              value={proposalsAnalytics?.month_rejected_proposals}
              color={THEME.danger}
              bgColor={THEME.dangerLight}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
